export * from "./boards";
import * as configs from "./configs";

export const board = {
    ...configs
}